module.exports = __webpack_public_path__ + "static/img/14001022.94c89dfc.png";